var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_box"},[_c('div',{staticClass:"feedback",attrs:{"id":"ManageTable"}},[(_vm.userType == 1)?_c('Adminstor'):_c('User')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }